import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <Card className="max-w-md w-full p-8 text-center">
        <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
        <h2 className="text-2xl font-bold mb-2">Pago Cancelado</h2>
        <p className="text-slate-600 mb-6">
          Has cancelado el proceso de pago. Puedes intentarlo nuevamente cuando estés listo.
        </p>
        <div className="space-y-3">
          <Button onClick={() => navigate('/client/dashboard')} className="w-full">
            Volver al Dashboard
          </Button>
          <Button onClick={() => navigate(-1)} variant="outline" className="w-full">
            Volver Atrás
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default PaymentCancel;